import { useLanguage } from "@/lib/LanguageContext";

export default function Marquee() {
    const { t } = useLanguage();
    const items = [...t.marquee, ...t.marquee];
    return (
        <section aria-hidden="true" data-testid="marquee-section" style={{ padding: "3rem 0", position: "relative", zIndex: 2 }}>
            <div className="ps-line" style={{ marginBottom: "2.5rem" }} />
            <div className="ps-marquee"><div className="ps-marquee-track">
                {items.map((it, i) => <span className="ps-marquee-item" key={i}>{it}<span className="dot" /></span>)}
            </div></div>
            <div className="ps-line" style={{ marginTop: "2.5rem" }} />
        </section>
    );
}
